import { actions } from './actions'

const initialState = {
  productosMasVendidos: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function productosMasVendidosReducer(state = initialState, action) {
  switch (action.type) {
    case actions.PRODUCTOS_MAS_VENDIDOS_LOAD_REQUESTED:
      return {
        ...state,
        productosMasVendidos: { ...state.productosMasVendidos, loading: true },
      }
    case actions.PRODUCTOS_MAS_VENDIDOS_LOAD_SUCCEEDED:
      return {
        ...state,
        productosMasVendidos: {
          ...state.productosMasVendidos,
          data: action.payload,
          loading: false,
        },
      }
    case actions.PRODUCTOS_MAS_VENDIDOS_LOAD_FILED:
      return {
        ...state,
        productosMasVendidos: {
          ...state.productosMasVendidos,
          loading: false,
          error: action.error,
        },
      }
    case actions.PRODUCTOS_MAS_VENDIDOS_INSERT_REQUESTED:
      return {
        ...state,
        productosMasVendidos: { ...state.productosMasVendidos, loading: true },
      }
    case actions.PRODUCTOS_MAS_VENDIDOS_INSERT_SUCCEEDED:
      return {
        ...state,
        productosMasVendidos: {
          ...state.productosMasVendidos,
          data: [...state.productosMasVendidos.data, action.payload],
          loading: false,
        },
      }
    case actions.PRODUCTOS_MAS_VENDIDOS_INSERT_FILED:
      return {
        ...state,
        productosMasVendidos: {
          ...state.productosMasVendidos,
          loading: false,
          error: action.error,
        },
      }
    case actions.PRODUCTOS_MAS_VENDIDOS_DELETE_REQUESTED:
      return {
        ...state,
        productosMasVendidos: { ...state.productosMasVendidos, loading: true, error: '' },
      }
    case actions.PRODUCTOS_MAS_VENDIDOS_DELETE_SUCCEEDED:
      return {
        ...state,
        productosMasVendidos: {
          ...state.productosMasVendidos,
          data: state.productosMasVendidos.data.filter(producto => producto.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.PRODUCTOS_MAS_VENDIDOS_DELETE_FILED:
      return {
        ...state,
        productosMasVendidos: {
          ...state.productosMasVendidos,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
